/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery, replacePXinStringWithEM } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SET STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    story: {
        width: '100%',
        height: '100%',
        position: 'relative',
        cursor: 'pointer',
        '& .hotspot': {
            position: 'relative',
            width: '100%',
            height: '100%',
            zIndex: 1,
            top: 0,
            transition: 'all .2s linear 0s'
        },
        '& .ctas': {
            textAlign: 'center',
            '& .button': {
                background: 'rgba(216, 216, 216, .3)',
                borderRadius: '0',
                height: pxToEm(36),
                fontSize: pxToEm(14),
                color: '#ffff',
                border: 'none',
                zIndex: 2,
                position: 'absolute',
                bottom: pxToEm(10),
                right: 0,
                padding: 0,
                width: 'fit-content',
                outline: 'none',
                // width: pxToEmWithBaseline({ value: 82, fontSizeBaseline: 14 }),
                // height: pxToEmWithBaseline({ value: 32, fontSizeBaseline: 14 }),
                // padding: 0,
                '&:hover': {
                    background: 'rgba(216, 216, 216, .5)'
                },
                //animation
                animationName: 'fadeInRight',
                animationDelay: '0s',
                animationDuration: '.4s',
                animationFillMode: 'forwards',
                '& .skipinner': {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    padding: replacePXinStringWithEM('10px 20px'),
                    '& i': {
                        marginLeft: pxToEm(5),
                        fontSize: pxToEm(12)
                    },
                    '& path': {
                      fill: '#fff'
                    }
                },
            },

        },

        '&.hotspothover-true': {
            '& .titletext': {
                textDecoration: 'underline'
            },
            '& .storylink': {
                textDecoration: 'underline'
            }
        },
        '&.large-true': {
            '& .storylink': {
                fontSize: '115%'
            }
        },
        '&.storySize-medium': { '& .titletext': {fontSize: pxToEm(26), lineHeight: '1.15' }},
        '&.storySize-large': { '& .titletext': {fontSize: pxToEm(24), lineHeight: '1.15' }},
        '&.storySize-xlarge': { '& .titletext': {fontSize: pxToEm(22), lineHeight: '1.15' }},
        '&.storySize-xxlarge': { '& .titletext': {fontSize: pxToEm(20), lineHeight: '1.15' }},
        '&.storySize-xxxlarge': { '& .titletext': {fontSize: pxToEm(20), lineHeight: '1.15' }},
    },
    [mediaQuery.medium]: {
        story:{
        '&.storySize-medium': { '& .titletext': {fontSize: pxToEm(32), lineHeight: '1.15' }},
        '&.storySize-large': { '& .titletext': {fontSize: pxToEm(30), lineHeight: '1.15' }},
        '&.storySize-xlarge': { '& .titletext': {fontSize: pxToEm(25), lineHeight: '1.15' }},
        '&.storySize-xxlarge': { '& .titletext': {fontSize: pxToEm(24), lineHeight: '1.15' }},
        '&.storySize-xxxlarge': { '& .titletext': {fontSize: pxToEm(24), lineHeight: '1.15' }},
        '& .storyelements': {
            transition: 'text-decoration .2s linear 0s',
            '&:hover':{
                textDecoration: 'underline'
                }
            }
        }
    },
    [mediaQuery.wide]: {
        story:{
            '&.storySize-medium': { '& .titletext': {fontSize: pxToEm(32), lineHeight: '1.15' }},
            '&.storySize-large': { '& .titletext': {fontSize: pxToEm(30), lineHeight: '1.15' }},
            '&.storySize-xlarge': { '& .titletext': {fontSize: pxToEm(28), lineHeight: '1.15' }},
            '&.storySize-xxlarge': { '& .titletext': {fontSize: pxToEm(26), lineHeight: '1.15' }},
            '&.storySize-xxxlarge': { '& .titletext': {fontSize: pxToEm(26), lineHeight: '1.15' }},
            '& .storyelements': {
                transition: 'text-decoration .2s linear 0s',
                '&:hover':{
                    textDecoration: 'underline'
                }
            }
        }
    }
};
